import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useParams } from "react-router-dom";
import Footer from "../components/Footer";
import HeaderOne from "../components/header/HeaderOne";
import axios from "axios";

function Tournament() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [teams, setTeams] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get("search"));

  useEffect(() => {
    getTournament();
  }, [isLoading]);

  const searchTeams = (e) => {
    e.preventDefault();
    if (search) {
      setSearchParams({ search: search });
    } else {
      searchParams.delete("search");
      setSearchParams(searchParams);
    }
    setIsLoading(true);
  };

  const getTournament = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/guest/tournaments/${id}/teams`,
        {
          params: {
            search: search,
          },
        }
      );

      const data = response.data.data;
      console.log(data);
      setTeams(data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <HeaderOne />
      <main>
        <section className="blog-area black-bg">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="blog-sidebar mb-4">
                  <div className="blog-widget">
                    <h4 className="widget-title">Searching</h4>
                    <div className="sidebar-search">
                      <form onSubmit={(e) => searchTeams(e)}>
                        <input
                          onChange={(e) => setSearch(e.target.value)}
                          value={search}
                          type="text"
                          placeholder="Search..."
                        />
                        <button type="submit">
                          <i className="fas fa-search" />
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="blog-sidebar">
                  <div className="blog-widget">
                    <h4 className="widget-title">Team Lists</h4>
                    <div className="rc-post-list">
                      <ul>
                        {!isLoading &&
                          teams.map((team) => {
                            return (
                              <div className="d-flex align-items-center justify-content-between">
                                <div>
                                  <li className="mb-4">
                                    <div className="rc-post-thumb">
                                      <img src={team.team_logo} alt="logo" />
                                    </div>
                                    <div className="rc-post-content">
                                      <h5 className="title">
                                        {team.full_team_name}
                                      </h5>
                                    </div>
                                  </li>
                                </div>
                                <Link
                                  className="btn-primary rounded px-4 py-2"
                                  to={`/tournaments/${id}/teams/${team.id}`}
                                >
                                  Detail
                                </Link>
                              </div>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Tournament;
